import { useMutation, useQueryClient } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { putUpdateUser } from "./putUpdateUser";
import { TUpdateUserBodyById } from "./types";
import { translations } from "../../../i18n/translations";
import { Queries } from "../../../constants/queries";
import { useLocation } from "react-router-dom";
import { Routing } from "../../../constants/routing";

export const useUpdateUserById = () => {
  const toast = useToast();
  const location = useLocation();
  const queryClient = useQueryClient();
  return useMutation<unknown, unknown, Partial<TUpdateUserBodyById>>(
    (payload) => putUpdateUser(payload),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.update_profile_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data, variables) => {
        if (location.pathname === Routing.Profile) {
          queryClient.invalidateQueries(Queries.User);
        } else {
          queryClient.invalidateQueries(
            Queries.UserById(+(variables.userId ?? 0))
          );
        }
      },
    }
  );
};
